<!-- Success Message -->
<div *ngIf="successMessage"
class="mb-4 p-4 rounded-lg bg-green-50 border border-green-200 text-green-700 flex items-center gap-2">

<span class="material-symbols-outlined">check_circle</span>
{{ successMessage }}

</div>

<!-- Error Message -->
<div *ngIf="errorMessage"
class="mb-4 p-4 rounded-lg bg-red-50 border border-red-200 text-red-700 flex items-center gap-2">

<span class="material-symbols-outlined">error</span>
{{ errorMessage }}

</div>

<main class="flex-grow w-full max-w-[1440px] mx-auto">
    <div class="p-8">
        <div
            class="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-8 bg-white p-6 rounded-2xl border border-slate-200 shadow-sm">
            <div>
                <div class="flex items-center gap-3">
                    <h1 class="text-2xl font-bold text-slate-800">Navigation Structure</h1>
                    <span
                        class="inline-flex items-center gap-1.5 px-3 py-1 bg-amber-50 text-amber-700 text-xs font-bold rounded-full border border-amber-200">
                        <span class="material-symbols-outlined text-sm">warning</span>
                        Menu is currently Live
                    </span>
                </div>
                <p class="text-slate-500 text-sm mt-1">Organize and manage your website's main navigation and sub-menus.
                </p>
            </div>
            <div class="flex items-center gap-6 w-full md:w-auto">
                <div class="flex items-center gap-4 bg-slate-50 px-5 py-2.5 rounded-xl border border-slate-100">
                    <div class="flex flex-col">
                        <span class="text-[10px] font-bold text-slate-400 uppercase tracking-widest">Global
                            Status</span>
                        <span class="text-xs font-bold text-slate-700">Menu System</span>
                    </div>
                    <div class="h-8 w-px bg-slate-200"></div>
                    <button aria-checked="true" class="toggle-switch toggle-bg-active" role="switch" type="button">
                        <span class="toggle-dot toggle-dot-active"></span>
                    </button>
                </div>
                <button (click)="openModal()"
                    class="flex-1 md:flex-none flex items-center justify-center gap-2 px-6 py-2.5 bg-primary text-white font-bold rounded-lg shadow-md hover:shadow-lg hover:bg-[#003d7e] transition-all text-sm">
                    <span class="material-symbols-outlined text-xl">add_circle</span>
                    <span>Add New Menu Item</span>
                </button>
            </div>
        </div>
        <div class="bg-white p-4 rounded-xl border border-slate-200 mb-6 flex flex-wrap gap-4 items-center shadow-sm">
            <div class="flex-grow max-w-md relative">
                <span
                    class="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">filter_list</span>
                <input
                    class="w-full pl-10 pr-4 py-2 border-slate-200 rounded-lg text-sm focus:ring-primary focus:border-primary"
                    placeholder="Filter by title or URL..." type="text" />
            </div>
            <select class="border-slate-200 rounded-lg text-sm focus:ring-primary focus:border-primary py-2 px-4">
                <option>All Levels</option>
                <option>Main Menu</option>
                <option>Sub-menu</option>
            </select>
            <select class="border-slate-200 rounded-lg text-sm focus:ring-primary focus:border-primary py-2 px-4">
                <option>All Status</option>
                <option>Visible</option>
                <option>Hidden</option>
            </select>
            <button class="ml-auto text-slate-500 hover:text-primary flex items-center gap-1 text-sm font-medium">
                <span class="material-symbols-outlined text-lg">refresh</span>
                Reset Filters
            </button>
        </div>
        <div class="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
            <div class="overflow-x-auto">
                <table class="w-full text-left border-collapse">
                    <thead>
                        <tr class="bg-slate-50 border-b border-slate-200">
                            <th class="py-4 px-6 w-12 text-slate-400 font-medium text-xs uppercase text-center"></th>
                            <th class="py-4 px-4 font-bold text-slate-600 text-xs uppercase tracking-wider">Menu Title
                                (KH / EN)</th>
                            <th class="py-4 px-4 font-bold text-slate-600 text-xs uppercase tracking-wider">URL / Link
                            </th>
                            <th class="py-4 px-4 font-bold text-slate-600 text-xs uppercase tracking-wider text-center">
                                Level</th>
                            <th class="py-4 px-4 font-bold text-slate-600 text-xs uppercase tracking-wider text-center">
                                Visibility</th>
                            <th class="py-4 px-4 font-bold text-slate-600 text-xs uppercase tracking-wider">Last Updated
                            </th>
                            <th class="py-4 px-6 text-right font-bold text-slate-600 text-xs uppercase tracking-wider">
                                Actions</th>
                        </tr>
                    </thead>
                    <tbody class="divide-y divide-slate-100">
                        <tr class="hover:bg-slate-50/50 transition-colors group">
                            <td class="py-4 px-6 text-center">
                                <span
                                    class="material-symbols-outlined drag-handle text-slate-300 group-hover:text-slate-400">drag_indicator</span>
                            </td>
                            <td class="py-4 px-4">
                                <div class="flex flex-col">
                                    <span class="text-sm font-bold text-slate-800">ទំព័រដើម</span>
                                    <span class="text-xs text-slate-500">Home</span>
                                </div>
                            </td>
                            <td class="py-4 px-4">
                                <span
                                    class="px-2 py-1 bg-slate-100 text-[11px] font-mono text-slate-600 rounded">/</span>
                            </td>
                            <td class="py-4 px-4 text-center">
                                <span
                                    class="px-2.5 py-1 bg-blue-50 text-blue-700 text-[10px] font-bold uppercase rounded-full border border-blue-100">Main
                                    Menu</span>
                            </td>
                            <td class="py-4 px-4 text-center">
                                <button aria-checked="true" class="toggle-switch toggle-bg-active mx-auto" role="switch"
                                    type="button">
                                    <span class="toggle-dot toggle-dot-active"></span>
                                </button>
                            </td>
                            <td class="py-4 px-4">
                                <div class="text-xs text-slate-500">
                                    <div class="font-medium text-slate-700">Oct 24, 2024</div>
                                    <div>14:30 PM</div>
                                </div>
                            </td>
                            <td class="py-4 px-6 text-right">
                                <div class="flex justify-end gap-1">
                                    <button class="p-2 text-primary hover:bg-blue-50 rounded-lg transition-colors"
                                        title="Add Sub-item">
                                        <span class="material-symbols-outlined text-xl">add_box</span>
                                    </button>
                                    <button
                                        class="p-2 text-slate-400 hover:text-primary hover:bg-slate-100 rounded-lg transition-colors"
                                        title="Edit">
                                        <span class="material-symbols-outlined text-xl">edit</span>
                                    </button>
                                    <button
                                        class="p-2 text-slate-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                                        title="Remove">
                                        <span class="material-symbols-outlined text-xl">delete</span>
                                    </button>
                                </div>
                            </td>
                        </tr>
                        <tr class="hover:bg-slate-50/50 transition-colors group">
                            <td class="py-4 px-6 text-center">
                                <span
                                    class="material-symbols-outlined drag-handle text-slate-300 group-hover:text-slate-400">drag_indicator</span>
                            </td>
                            <td class="py-4 px-4">
                                <div class="flex flex-col">
                                    <span class="text-sm font-bold text-slate-800">អំពីយើង</span>
                                    <span class="text-xs text-slate-500">About Us</span>
                                </div>
                            </td>
                            <td class="py-4 px-4">
                                <span
                                    class="px-2 py-1 bg-slate-100 text-[11px] font-mono text-slate-600 rounded">/about</span>
                            </td>
                            <td class="py-4 px-4 text-center">
                                <span
                                    class="px-2.5 py-1 bg-blue-50 text-blue-700 text-[10px] font-bold uppercase rounded-full border border-blue-100">Main
                                    Menu</span>
                            </td>
                            <td class="py-4 px-4 text-center">
                                <button aria-checked="true" class="toggle-switch toggle-bg-active mx-auto" role="switch"
                                    type="button">
                                    <span class="toggle-dot toggle-dot-active"></span>
                                </button>
                            </td>
                            <td class="py-4 px-4">
                                <div class="text-xs text-slate-500">
                                    <div class="font-medium text-slate-700">Oct 20, 2024</div>
                                    <div>09:15 AM</div>
                                </div>
                            </td>
                            <td class="py-4 px-6 text-right">
                                <div class="flex justify-end gap-1">
                                    <button class="p-2 text-primary hover:bg-blue-50 rounded-lg transition-colors"
                                        title="Add Sub-item">
                                        <span class="material-symbols-outlined text-xl">add_box</span>
                                    </button>
                                    <button
                                        class="p-2 text-slate-400 hover:text-primary hover:bg-slate-100 rounded-lg transition-colors"
                                        title="Edit">
                                        <span class="material-symbols-outlined text-xl">edit</span>
                                    </button>
                                    <button
                                        class="p-2 text-slate-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                                        title="Remove">
                                        <span class="material-symbols-outlined text-xl">delete</span>
                                    </button>
                                </div>
                            </td>
                        </tr>
                        <tr class="hover:bg-slate-50/50 transition-colors group bg-slate-50/30">
                            <td class="py-4 px-6 text-center">
                                <span
                                    class="material-symbols-outlined drag-handle text-slate-300 group-hover:text-slate-400">drag_indicator</span>
                            </td>
                            <td class="py-4 px-4">
                                <div class="flex items-center gap-3">
                                    <span
                                        class="material-symbols-outlined text-slate-300 text-lg">subdirectory_arrow_right</span>
                                    <div class="flex flex-col">
                                        <span class="text-sm font-medium text-slate-700">រចនាសម្ព័ន្ធក្រសួង</span>
                                        <span class="text-[11px] text-slate-400 italic">Ministry Structure</span>
                                    </div>
                                </div>
                            </td>
                            <td class="py-4 px-4">
                                <span
                                    class="px-2 py-1 bg-slate-100 text-[11px] font-mono text-slate-600 rounded">/about/structure</span>
                            </td>
                            <td class="py-4 px-4 text-center">
                                <span
                                    class="px-2.5 py-1 bg-slate-100 text-slate-600 text-[10px] font-bold uppercase rounded-full border border-slate-200">Sub-menu</span>
                            </td>
                            <td class="py-4 px-4 text-center">
                                <button aria-checked="true" class="toggle-switch toggle-bg-active mx-auto" role="switch"
                                    type="button">
                                    <span class="toggle-dot toggle-dot-active"></span>
                                </button>
                            </td>
                            <td class="py-4 px-4">
                                <div class="text-xs text-slate-500">
                                    <div class="font-medium text-slate-700">Oct 20, 2024</div>
                                    <div>09:20 AM</div>
                                </div>
                            </td>
                            <td class="py-4 px-6 text-right">
                                <div class="flex justify-end gap-1">
                                    <button class="p-2 text-primary hover:bg-blue-50 rounded-lg transition-colors"
                                        title="Add Sub-item">
                                        <span class="material-symbols-outlined text-xl">add_box</span>
                                    </button>
                                    <button
                                        class="p-2 text-slate-400 hover:text-primary hover:bg-slate-100 rounded-lg transition-colors"
                                        title="Edit">
                                        <span class="material-symbols-outlined text-xl">edit</span>
                                    </button>
                                    <button
                                        class="p-2 text-slate-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                                        title="Remove">
                                        <span class="material-symbols-outlined text-xl">delete</span>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="bg-slate-50 border-t border-slate-200 px-6 py-4 flex items-center justify-between">
                <span class="text-xs text-slate-500 font-medium tracking-wide">Showing 1-10 of 24 menu items</span>
                <div class="flex gap-2">
                    <button
                        class="px-3 py-1 border border-slate-200 rounded bg-white text-slate-400 hover:bg-slate-50 disabled:opacity-50"
                        disabled="">
                        <span class="material-symbols-outlined text-sm">chevron_left</span>
                    </button>
                    <button
                        class="px-3 py-1 border border-primary bg-primary text-white rounded text-xs font-bold">1</button>
                    <button
                        class="px-3 py-1 border border-slate-200 rounded bg-white text-slate-600 hover:bg-slate-50 text-xs font-bold">2</button>
                    <button
                        class="px-3 py-1 border border-slate-200 rounded bg-white text-slate-600 hover:bg-slate-50 text-xs font-bold">3</button>
                    <button class="px-3 py-1 border border-slate-200 rounded bg-white text-slate-600 hover:bg-slate-50">
                        <span class="material-symbols-outlined text-sm">chevron_right</span>
                    </button>
                </div>
            </div>
        </div>
        
    </div>
</main>


<!-- Modal -->
<div *ngIf="isModalOpen" class="fixed inset-0 bg-black/40 flex items-center justify-center z-50">

<div class="bg-white w-[600px] rounded-2xl shadow-xl p-6">

<div class="flex justify-between items-center mb-4">
<h2 class="text-lg font-bold text-slate-700">Add Menu Item</h2>

<button (click)="closeModal()">
<span class="material-symbols-outlined text-slate-500">close</span>
</button>
</div>

<!-- Menu Title -->
<div class="grid grid-cols-2 gap-4 mb-4">

<div>
<label class="text-sm font-medium text-slate-600">Menu Title (KH)</label>
<input
type="text"
[(ngModel)]="menuForm.titleKh"
class="w-full mt-1 border rounded-lg px-3 py-2 text-sm"
placeholder="ឈ្មោះម៉ឺនុយ">
</div>

<div>
<label class="text-sm font-medium text-slate-600">Menu Title (EN)</label>
<input
type="text"
[(ngModel)]="menuForm.titleEn"
class="w-full mt-1 border rounded-lg px-3 py-2 text-sm"
placeholder="Menu Name">
</div>

</div>

<!-- URL -->
<div class="mb-4">
<label class="text-sm font-medium text-slate-600">URL / Link</label>
<input
type="text"
[(ngModel)]="menuForm.url"
class="w-full mt-1 border rounded-lg px-3 py-2 text-sm"
placeholder="/about">
</div>

<!-- Icon -->
<div class="mb-4">
<label class="text-sm font-medium text-slate-600">Icon</label>
<input
type="text"
[(ngModel)]="menuForm.icon"
class="w-full mt-1 border rounded-lg px-3 py-2 text-sm"
placeholder="material icon name">
</div>

<!-- Parent + Level -->
<div class="grid grid-cols-2 gap-4 mb-4">

<div>
<label class="text-sm font-medium text-slate-600">Parent Menu</label>
<select
[(ngModel)]="menuForm.parentMenu"
class="w-full mt-1 border rounded-lg px-3 py-2 text-sm">

<option value="">Main Menu</option>
<option value="about">About Us</option>
<option value="service">Service</option>

</select>
</div>

<div>
<label class="text-sm font-medium text-slate-600">Menu Level</label>
<select
[(ngModel)]="menuForm.level"
class="w-full mt-1 border rounded-lg px-3 py-2 text-sm">

<option value="main">Main Menu</option>
<option value="sub">Sub Menu</option>

</select>
</div>

</div>

<!-- Status -->
<div class="mb-6">
<label class="text-sm font-medium text-slate-600">Visibility</label>

<select
[(ngModel)]="menuForm.status"
class="w-full mt-1 border rounded-lg px-3 py-2 text-sm">

<option value="visible">Visible</option>
<option value="hidden">Hidden</option>

</select>

</div>

<!-- Buttons -->
<div class="flex justify-end gap-3">

<button
(click)="closeModal()"
class="px-4 py-2 border rounded-lg text-sm">
Cancel
</button>

<button
(click)="saveMenu()"
class="px-4 py-2 bg-primary text-white rounded-lg text-sm">
Save Menu
</button>

</div>

</div>
</div>